<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">
    <!--    <FetchSettingList v-if="authState && AppActiveUser" />-->
    <FetchUserList v-if="authState && AppActiveUser" />
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
// TODO import FetchSettingList from "@/modules/setting/components/FetchSettingList";
import { firebase } from "@/utilities/firebase";
import FetchUserList from "@/modules/user/components/FetchUserList";
// TODO import { getAustralianData } from "@/modules/dashboard/utilities/australianStatisticsCalculator";
import { getVictorianData } from "@/modules/dashboard/utilities/victorianStatisticsCalculator";
import { fetchRssResults } from "@/modules/dashboard/utilities/rssRetriever";

export default {
  components: {
    FetchUserList
  },
  data() {
    return {
      vueAppClasses: [],
      feeds: [
        {
          journal: "lancet",
          feedName: "Lancet: current",
          url: "https://www.thelancet.com/rssfeed/lancet_current.xml",
          useDate: false,
          loaded: false
        },
        {
          journal: "lancet",
          feedName: "Lancet: infectious disease",
          url: "http://www.thelancet.com/rssfeed/laninf_current.xml",
          useDate: false,
          loaded: false
        },
        {
          journal: "lancet",
          feedName: "Lancet: collection COVID",
          url: "https://www.thelancet.com/collection/rss/001581",
          useDate: false,
          loaded: false
        },
        {
          journal: "lancet",
          feedName: "Lancet: respiratory disease",
          url: "http://www.thelancet.com/rssfeed/lanres_current.xml",
          useDate: false,
          loaded: false
        },
        {
          journal: "nejm",
          feedName: "NEJM: medical news",
          url: "https://www.jwatch.org/medical-news/rss",
          useDate: false,
          loaded: false
        },
        {
          journal: "nejm",
          feedName: "NEJM: infectious disease",
          url: "https://www.jwatch.org/infectious-diseases/rss",
          useDate: false,
          loaded: false
        },
        {
          journal: "nejm",
          feedName: "NEJM: respiratory infections",
          url: "https://www.jwatch.org/respiratory-infections/rss",
          useDate: false,
          loaded: false
        },
        {
          journal: "jama",
          feedName: "JAMA: clinical reviews",
          url: "https://jamaclinicalreviews.libsyn.com/rss",
          useDate: true,
          loaded: false
        },
        {
          journal: "jama",
          feedName: "JAMA: medical news",
          url: "https://jamamedicalnews.libsyn.com/rss",
          useDate: true,
          loaded: false
        },
        {
          journal: "jama",
          feedName: "JAMA Network: COVID-19 Q&A",
          url: "https://covid19jama.libsyn.com/rss",
          useDate: true,
          loaded: false
        },
        {
          journal: "ersj",
          feedName: "ERSJ: Recent",
          url: "https://erj.ersjournals.com/rss/recent.xml",
          useDate: true,
          loaded: false
        },
        {
          journal: "ersj",
          feedName: "ERSJ: Review",
          url: "https://err.ersjournals.com/rss/recent.xml",
          useDate: true,
          loaded: false
        },
        {
          journal: "ersj",
          feedName: "ERSJ: open research",
          url: "https://openres.ersjournals.com/rss/recent.xml",
          useDate: true,
          loaded: false
        }
      ]
    };
  },
  computed: {
    AppActiveUser() {
      return this.$store.state.AppActiveUser.id
        ? this.$store.state.AppActiveUser
        : false;
    },
    authState() {
      return firebase.auth().currentUser;
    }
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    }
  },
  methods: {
    getRssResults(feedUrl, mutationName, useDate) {
      fetchRssResults(feedUrl, useDate)
        .then(response => {
          this.$store.commit(mutationName, response);
        })
        .catch(error => {
          console.error(error);
        });
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    const covidLiveFunction = firebase.functions().httpsCallable("fetchData");

    covidLiveFunction().then(result => {
      let covidData = result.data;
      let filteredCovidData = covidData.filter(dataPoint => {
        return dataPoint.CODE === "AUS" || dataPoint.CODE === "VIC";
      });

      let dateFilteredData = filteredCovidData.filter(dataPoint => {
        let date = new Date(dataPoint.REPORT_DATE);
        let targetDate = new Date("2020-03-01");
        return date >= targetDate;
      });

      let vicData = dateFilteredData.filter(dataPoint => {
        return dataPoint.CODE === "VIC";
      });
      let ausData = dateFilteredData.filter(dataPoint => {
        return dataPoint.CODE === "AUS";
      });

      let dateRange = vicData.map(dataPoint => {
        return dataPoint.REPORT_DATE;
      });

      let reversedDateRange = dateRange.reverse();

      let formattedDateRange = reversedDateRange.map(date => {
        let dateObject = new Date(date);
        let formattedDate = dateObject.toLocaleString("en-AU", {
          month: "2-digit",
          day: "2-digit"
        });

        return formattedDate;
      });

      let totalVicTest = {
        backgroundColor: "rgba(0, 1, 125, 0.8)",
        label: "Total Tests",
        data: vicData
          .map(dataPoint => {
            return dataPoint.TEST_CNT;
          })
          .reverse()
      };

      let totalVicHospital = {
        backgroundColor: "rgba(0, 1, 125, 0.8)",
        label: "Total Hospitalisations",
        data: vicData
          .map(dataPoint => {
            return dataPoint.MED_HOSP_CNT;
          })
          .reverse()
      };

      let totalVicIcu = {
        backgroundColor: "rgba(0, 1, 125, 0.8)",
        label: "Total ICU",
        data: vicData
          .map(dataPoint => {
            return dataPoint.MED_ICU_CNT;
          })
          .reverse()
      };

      let totalVicVentilator = {
        backgroundColor: "rgba(0, 1, 125, 0.8)",
        label: "Total Ventilations",
        data: vicData
          .map(dataPoint => {
            return dataPoint.MED_VENT_CNT;
          })
          .reverse()
      };

      let totalAusTest = {
        backgroundColor: "rgba(0, 132, 61, 0.5)",
        label: "Total Tests",
        data: ausData
          .map(dataPoint => {
            return dataPoint.TEST_CNT;
          })
          .reverse()
      };

      let totalAusHospital = {
        backgroundColor: "rgba(0, 132, 61, 0.5)",
        label: "Total Hospitalisations",
        data: ausData
          .map(dataPoint => {
            return dataPoint.MED_HOSP_CNT;
          })
          .reverse()
      };

      let totalAusIcu = {
        backgroundColor: "rgba(0, 132, 61, 0.5)",
        label: "Total ICU",
        data: ausData
          .map(dataPoint => {
            return dataPoint.MED_ICU_CNT;
          })
          .reverse()
      };

      let totalAusVentilator = {
        backgroundColor: "rgba(0, 132, 61, 0.5)",
        label: "Total Ventilations",
        data: ausData
          .map(dataPoint => {
            return dataPoint.MED_VENT_CNT;
          })
          .reverse()
      };

      let vicDataSets = {
        totalVicTest: totalVicTest,
        totalVicHospital: totalVicHospital,
        totalVicIcu: totalVicIcu,
        totalVicVentilator: totalVicVentilator
      };

      let liveVicData = {
        dateRange: formattedDateRange,
        dataSets: vicDataSets
      };

      this.$store.commit("UPDATE_VICTORIAN_LIVE_DATA", liveVicData);

      let ausDataSets = {
        totalAusTest: totalAusTest,
        totalAusHospital: totalAusHospital,
        totalAusIcu: totalAusIcu,
        totalAusVentilator: totalAusVentilator
      };

      let liveAusData = {
        dateRange: formattedDateRange,
        dataSets: ausDataSets
      };

      this.$store.commit("UPDATE_AUSTRALIAN_LIVE_DATA", liveAusData);
    });

    //get victorian data and load it into vuex state
    getVictorianData()
      .then(victorianData => {
        this.$store.dispatch("updateVictorianData", victorianData);
      })
      .catch(error => {
        console.error(error);
      });

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // Get RSS articles
    this.feeds.forEach(feed => {
      if (!feed.loaded) {
        let mutationName = `PUSH_${feed.journal.toUpperCase()}_RSS_RESULTS`;
        this.getRssResults(feed.url, mutationName, feed.useDate);
        feed.loaded = true;
      }
    });
  },
  async created() {
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Barlow:wght@300&family=Forum&family=Lora&family=Marcellus&family=Roboto:wght@300;500&family=Source+Sans+Pro:wght@600&display=swap");

.column-margin {
  margin: 0.75rem;
}

.lancet {
  h4,
  h3 {
    color: #000 !important;
    font-family: "Marcellus", serif !important;
    letter-spacing: 1.2px !important;
    text-transform: uppercase !important;
  }

  a {
    color: #ff8200 !important;
    font-family: "Source Sans Pro", sans-serif !important;
  }

  p.article-title {
    font-weight: 600 !important;
    color: #004480 !important;
    font-family: Source Sans Pro !important;
    font-size: 1rem !important;
  }

  p.article-date {
    color: #000 !important;
  }

  p span {
    font-family: Source Sans Pro !important;
  }

  .pageLink:hover {
    cursor: pointer;
  }
}

.nejm {
  h4,
  h3 {
    color: #1a1a1a !important;
    font-family: "Forum", serif !important;
    font-weight: 600 !important;
    letter-spacing: 1.3px !important;
    text-transform: uppercase !important;

    span {
      font-size: small !important;
      font-family: Lora !important;
      letter-spacing: normal !important;
      font-weight: normal !important;
    }
  }

  a {
    color: #f30 !important;
    font-family: "Source Sans Pro", sans-serif !important;
  }

  p.article-title {
    font-weight: 600 !important;
    color: #1a1a1a !important;
    font-family: Lora !important;
    font-size: 0.9rem !important;
  }

  p.article-date {
    color: #1a1a1a !important;
  }

  p span {
    font-family: Source Sans Pro !important;
  }

  .pageLink:hover {
    cursor: pointer;
  }
}

.jama {
  h4,
  h3 {
    font-family: "Roboto", sans-serif !important;
    font-weight: 500 !important;
    text-transform: uppercase !important;

    span {
      text-transform: uppercase !important;
      font-weight: 300 !important;
    }
  }

  a {
    color: #d71635 !important;
    font-family: "Source Sans Pro", sans-serif !important;
  }

  p.article-title {
    font-weight: 600 !important;
    color: #333 !important;
    font-family: Roboto !important;
    font-size: 1rem !important;
  }

  p.article-date {
    color: #1a1a1a !important;
  }

  p span {
    font-family: Source Sans Pro !important;
  }

  .pageLink:hover {
    cursor: pointer;
  }
}

.ersj {
  h4,
  h3 {
    color: #313131 !important;
    font-family: "Barlow", sans-serif !important;
    font-weight: 300 !important;
  }

  a {
    color: #464646 !important;
    font-family: "Source Sans Pro", sans-serif !important;
  }

  p.article-title {
    font-weight: 600 !important;
    color: #005594 !important;
    font-family: Forum !important;
    font-size: 1.1rem !important;
  }

  p.article-date {
    color: #313131 !important;
  }

  p span {
    font-family: Source Sans Pro !important;
  }

  .pageLink:hover {
    cursor: pointer;
  }
}
</style>
